import axios, { AxiosRequestConfig } from 'axios';

export async function makePostRequest(
    url: string,
    data: AxiosRequestConfig['data'],
    config: AxiosRequestConfig = {}
) {
  try {
    const axiosInstance = axios.create();
    const res = await axiosInstance.post(url, data, {
      ...config,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function makeGetRequest(
    url: string,
    config: AxiosRequestConfig = {}
) {
  try {
    const axiosInstance = axios.create();
    const res = await axiosInstance.get(url, {
      ...config,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
}


// WEBPACK FOOTER //
// ./src/services/RequestHelpers.ts